import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import SolarTopNavPc from '@/components/solarSumPage/solartopnav';
import SolarTopNavH5 from '@/componentsH5/solarSumPage/solartopnav';
import EFAccessories from '@/components/UI/svg/Naver/Icons/EFAccessories';
import EFComparisonsmall from '@/components/UI/svg/Naver/Icons/EFComparisonsmall';
import { PRODUCT_SORT, PRODUCT_SORT_NA, POWER_SERIES_SORT, HIDE_PRODUCT } from '@/constants/productSort';
import EFCaculators from '@/components/UI/svg/Naver/Icons/EFCaculators';
import { NEW_VISION_SITE } from '@/constants/solar-calculator';

// smart
const idObj: any = {
    delta: '1468461504103563266',
    river: '1468461339749761025', //多了river2的2个
    solar: '1468461916013576194',
};

const queryMatch: any = {
    'portable-power-stations': 'delta',
    power: 'delta',
    'solar-panels': 'solar',
    solar: 'solar',
    'smart-home-ecosystem': 'smart',
    smart: 'smart',
    'smart-devices': 'smart',
};

const AccessoriesName = ({ title }: { title: string }) => (
    <>
        {title}
        <EFArrowUp style={{ marginLeft: '3px' }} />
    </>
);

const ComparisonName = ({ title }: { title: string }) => (
    <>
        {title}
        <EFArrowUp style={{ marginLeft: '3px' }} />
    </>
);

const getListBInit = (datatype: string, locale: any, t: any) => {
    const accessoriesTitle = t('navigation.powerStationLev1.product_delta.site_product_accessories');
    const comparisonTitle = t('navigation.powerStationLev1.product_delta.site_product_comparison');

    const dataAllObjB: any = {
        delta: {
            datatype: 'delta',
            list: [
                {
                    isAccessories: true,
                    icons: <EFAccessories />,
                    iconName: accessoriesTitle,
                    name: <AccessoriesName title={accessoriesTitle} />,
                    detLink: `/${locale}/accessories?id=1468461019837612033`,
                },
                {
                    isComparison: true,
                    icons: <EFComparisonsmall />,
                    iconName: comparisonTitle,
                    name: <ComparisonName title={comparisonTitle} />,
                    detLink: `/${locale}/compare/delta?id=1468461019837612033&productCatagoryId=1468461504103563266`,
                },
            ],
        },
        river: {
            datatype: 'river',
            list: [
                {
                    isAccessories: true,
                    icons: <EFAccessories />,
                    iconName: accessoriesTitle,
                    name: <AccessoriesName title={accessoriesTitle} />,
                    detLink: `/${locale}/accessories?id=1468461019837612033`,
                },
                {
                    isComparison: true,
                    icons: <EFComparisonsmall />,
                    iconName: comparisonTitle,
                    name: <ComparisonName title={comparisonTitle} />,
                    detLink: `/${locale}/compare/river?id=1468461019837612033&productCatagoryId=1468461339749761025`,
                },
            ],
        },
        solar: {
            datatype: 'solar',
            list: [
                {
                    isAccessories: true,
                    icons: <EFAccessories />,
                    iconName: accessoriesTitle,
                    name: <AccessoriesName title={accessoriesTitle} />,
                    detLink: `/${locale}/accessories?id=1468461916013576194`,
                },
                {
                    isComparison: true,
                    icons: <EFComparisonsmall />,
                    iconName: comparisonTitle,
                    name: <ComparisonName title={comparisonTitle} />,
                    detLink: `/${locale}/compare/solar?id=1468461916013576194&productCatagoryId=1468461916013576194`,
                },
            ],
        },
        smart: {
            datatype: 'smart',
            list: [
                {
                    isAccessories: true,
                    icons: <EFAccessories />,
                    iconName: accessoriesTitle,
                    name: <AccessoriesName title={accessoriesTitle} />,
                    detLink: `/${locale}/accessories?id=1468462465052164098`,
                },
            ],
        },
    };
    // us, ca, eu添加新版太阳能计算器入口
    if (NEW_VISION_SITE.includes(locale)) {
        dataAllObjB.solar.list.push({
            icons: <EFCaculators />,
            name: t('navigation.solar_panel.calculators_title'),
            label: false,
            detLink: `/${locale}/calculators/solarpanels`,
        });
    }
    return dataAllObjB[datatype]?.list || [];
};

export default function NaverT({ query, callback, categoryList }: any) {
    if (!query) {
        return null;
    }
    const { useLang, gtm, gloproductlist, isMobile } = useGlobal();
    const { t } = useLang('shared');
    const router = useRouter();
    const { locale = 'us' } = router;
    const SORT_B = ['us', 'ca'].includes(locale) ? PRODUCT_SORT_NA : PRODUCT_SORT;

    const initListData2 = (datatype: string) => {
        const listA: any = [];
        // 台湾站隐藏配件页 对比页
        const listB = ['tw', 'kr'].includes(locale) ? [] : getListBInit(datatype, locale, t) || [];

        // 补充 delta,river的一级
        if (datatype === 'delta' || datatype === 'river') {
            categoryList?.forEach((category: any) => {
                let datatypeA = datatype;
                if (category.generalKey === 'product_ps_river') {
                    datatypeA = 'river';
                }

                if (POWER_SERIES_SORT.includes(category.generalKey)) {
                    listA.push({
                        datatype: datatypeA,
                        generalKey: category.generalKey,
                        text: category.name,
                        productCatagoryId: category.sourceId,
                    });
                }
            });
        }

        const productCatagoryId = idObj[datatype];

        if (productCatagoryId) {
            // 能从父级取数据
            gloproductlist.map((item: any) => {
                if (['us', 'ca'].includes(locale)) {
                    if (item.productCatagoryId === productCatagoryId) {
                        if (HIDE_PRODUCT.includes(item.generalKey)) {
                            listB.unshift({
                                detLink: `/river-2-portable-power-station`,
                                name: item.name,
                                imgSrc: item.navImage,
                                generalKey: item.generalKey,
                                tag: item.label,
                            });
                        } else {
                            listB.unshift({
                                detLink: `/${item.url}`,
                                name: item.name,
                                imgSrc: item.navImage,
                                generalKey: item.generalKey,
                                tag: item.label,
                            });
                        }
                    }
                } else {
                    if (item.productCatagoryId === productCatagoryId && !HIDE_PRODUCT.includes(item.generalKey)) {
                        listB.unshift({
                            detLink: `/${item.url}`,
                            name: item.name,
                            imgSrc: item.navImage,
                            generalKey: item.generalKey,
                            tag: item.label,
                        });
                    }
                }
            });
        } else if (datatype === 'smart') {
            const smartCategoryId = categoryList.find((item: any) => item.generalKey === 'product_smart')?.sourceId;
            const smartSubCategories = categoryList.filter((item: any) => item.pid === smartCategoryId).map((item: any) => item.sourceId);

            smartSubCategories?.forEach((item1: any) => {
                gloproductlist.map((item: any) => {
                    if (item1 === item.productCatagoryId) {
                        listB.unshift({
                            detLink: `/${item.url}`,
                            name: item.name,
                            imgSrc: item.navImage,
                            generalKey: item.generalKey,
                            tag: item.label,
                        });
                    }
                });
            });
        }

        listA?.sort((a: any, b: any) => POWER_SERIES_SORT.indexOf(b.generalKey) - POWER_SERIES_SORT.indexOf(a.generalKey));
        listB?.sort((a: any, b: any) => SORT_B.indexOf(b.generalKey) - SORT_B.indexOf(a.generalKey));

        return {
            listA,
            listB,
        };
    };

    const [powerActiveKey, setPowerActiveKey] = useState(queryMatch[query]);
    const [navDataA, setNavDataA] = useState<any[]>([]);
    const [navDataB, setNavDataB] = useState<any[]>([]);

    const tabChange = (item: any) => {
        if (item.id == powerActiveKey) {
            return;
        }
        setPowerActiveKey(item.datatype);
        setNavDataB(initListData2(item.datatype).listB);
        gtm.push({
            event: 'uaEvent',
            event_name: 'top_second_navigation',
            navigation_name: item.text,
        });
        callback && callback(item.generalKey); //切换父级的数据
    };

    useEffect(() => {
        setPowerActiveKey(queryMatch[query]);
        const data = initListData2(queryMatch[query]);
        setNavDataA(data.listA);
        setNavDataB(data.listB);
    }, [query]);

    return (
        <div className={`${css.naverT} naverT ${isMobile ? 'naverT-h5' : 'naverT-pc'}`}>
            <div className="container-box">
                {navDataA.length > 1 && (
                    <div className="nav-tab-header">
                        <div className="nav-tab-header-in">
                            {navDataA?.map((item: any) => (
                                <div
                                    className={`nav-tab-header-item ${powerActiveKey == item.datatype ? 'active' : ''}`}
                                    onClick={() => tabChange(item)}
                                    key={item.generalKey}
                                >
                                    {item.text}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {isMobile && <SolarTopNavH5 query={query} powerActiveKey={powerActiveKey} navList={navDataB} />}
                {!isMobile && <SolarTopNavPc query={query} powerActiveKey={powerActiveKey} navList={navDataB} />}
            </div>
        </div>
    );
}
